module.exports = __webpack_public_path__ + "static/rainbowbabyvest-eddf3030d9827a03507e4d8c03c7e3bc.jpeg";